const DurationsFoundationsThemes = {
    duration_50: '0.001s',
    duration_100: '0.15s',
    duration_125: '0.25s',
    duration_150: '0.3s',
    duration_175: '0.5s',
    duration_200: '0.8s',
    duration_250: '1s',
    duration_300: '1.2s',
    duration_400: '0.6s',
};
export { DurationsFoundationsThemes };
//# sourceMappingURL=durations-foundations.themes.js.map